export enum APPS {
  FILE_EXPLORER = 'File Explorer',
  CALCULATOR = 'Calculator',
  BACKGROUND = 'Background',
  STONKS = 'Stonks',
  PROFILE = 'Profile',
  IMPERIUM = 'Imperium',
}

export enum DESKTOP_ITEMS {
  RECYCLE_BIN = 'Recycle Bin',
  GAMES = 'Games',
}

export enum PATHS {
  DESKTOP = 'C:\\Users\\Desktop',
  DESKTOP_GAMES = 'C:\\Users\\Desktop\\Games',
  DESKTOP_RECYCLE_BIN = 'C:\\Users\\Desktop\\Recycle Bin',
  PICTURES = 'C:\\Users\\Pictures',
  USERS = 'C:\\Users',
}

export enum WINDOW_CONTROLS {
  CLOSE = 'Close',
  MINIMIZE = 'Minimize',
  MAXIMIZE = 'Maximize',
  RESTORE = 'Restore',
}

export enum FILE_TYPES {
  FOLDER = 'folder',
  FILE = 'file',
  APP = 'app',
  GAME = 'game',
}
